export default __webpack_public_path__ + "static/media/15919-luke.bf8a2c66.pdf";